import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';
import {AccountService} from '../../singelton/account.service';
@Injectable({providedIn: 'root' })
export class GuestGuard implements CanActivate {
  constructor(private accountService: AccountService , private router: Router) {}
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    // if the use is authenticated the path is blocked
    if(this.accountService.isAuthenticated()){
      this.router.navigate(['/dashboard/dashboard']);
      return  false;
    }
        return true;
      }
    }
